module.exports = __webpack_public_path__ + "static/img/units.77817ae2.png";